export default __webpack_public_path__ + "static/media/slider1-left.1cabc6a2.svg";